import React from 'react';

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error("ErrorBoundary atrapó un error:", error, errorInfo);
        this.setState({ errorInfo });
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '60vh',
                    color: '#ff3333'
                }}>
                    <h1>¡Ups! Algo salió mal.</h1>
                    <p>Por favor, recarga la página. Si el problema persiste, contacta a soporte.</p>
                    <details style={{ whiteSpace: 'pre-wrap', color: '#aaa', maxWidth: '800px' }}>
                        <summary>Detalles técnicos</summary>
                        {this.state.error && this.state.error.toString()}
                        {'\n\n'}
                        {this.state.errorInfo && this.state.errorInfo.componentStack}
                    </details>
                </div>
            );
        }
        return this.props.children;
    }
}